import { BASE, CATEGORY, COLOR, FILTERS, JARGON, KEY_VALUES, PATH, SCOPE, TAB } from "../../../modules/constants"

export const getTabIndex = (pathname, features) => {
  switch (pathname.split('/')[1]) {

    case PATH[BASE.LSE.COMPANIES]:
      return TAB[BASE.LSE.COMPANIES].INDEX

    case PATH[BASE.LSE.ROLES]:
      return TAB[BASE.LSE.ROLES].INDEX

    case PATH[BASE.LSE.PEOPLE]:
      return TAB[BASE.LSE.PEOPLE].INDEX

    case PATH[BASE.LSE.NEWS]:
      return TAB[BASE.LSE.NEWS].INDEX

    case PATH[BASE.LSE.ADVISERS]:
      return TAB[BASE.LSE.ADVISERS].INDEX

    case PATH[BASE.FAVOURITES]:
      return TAB[BASE.FAVOURITES].INDEX

    case PATH[BASE.COMPANY]:
      return TAB[BASE.COMPANY].INDEX

    case PATH[BASE.PERSON]:
      return TAB[BASE.PERSON].INDEX

    case PATH[BASE.NEWS_RELEASE]:
      return TAB[BASE.NEWS_RELEASE].INDEX

    case PATH[BASE.SEARCH]:
      return TAB[BASE.SEARCH].INDEX

    default:
      return TAB[features.MaxLseData ? BASE.DASHBOARD : BASE.SEARCH].INDEX
  }
}

export const analyseQuery = props => {
  let params = new URLSearchParams(props.location.search)
  return {
    searchString: params.get("search-string"),
    filter: params.get("filter"),
    nexusView: parseInt(params.get("view"), 10) || 0,
    seed: params.get("seed"),
    urlScope: validateScope(params.get("scope"), props.scope),
    urlSource: params.get("source") || "numerable",
    urlTrialCode: params.get("trial") || null,
  }
}

const validateScope = (paramsScope, propsScope) =>
  Object.keys(SCOPE).some(s => SCOPE[s] === paramsScope)
    ? paramsScope
    : propsScope

export const wouldExceedMaxCount = (entity, favourites) => {
  let favouritesCount = entity.category === CATEGORY.COMPANY
    ? favourites.companies.length
    : favourites.people.length
  return favouritesCount >= KEY_VALUES.MAX_FAVOURITES
}

export const initBranding = sourceUrl => {
  // Sets the various constant props depending on brand
  // console.log('sourceUrl:',sourceUrl)
  switch (sourceUrl) {
    case JARGON.THE350CLUB:
      COLOR.BRAND.STD = COLOR.BRAND.THE350CLUB
      COLOR.BRAND.LIGHT = COLOR.BRAND.THE350CLUB_LIGHT
      FILTERS.BLACK_TO_BRAND = FILTERS.BLACK_TO_350CLUB_COLOR
      break

    default:
      COLOR.BRAND.STD = COLOR.BRAND.NUMERABLE
      COLOR.BRAND.LIGHT = COLOR.BRAND.NUMERABLE_LIGHT
      FILTERS.BLACK_TO_BRAND = FILTERS.BLACK_TO_NUMERABLE_PURPLE
      break
  }
}
